import React, { Component } from "react";
import { connect } from "react-redux";
import { numberWithDots } from '../../../helpers';
import PriceWrapper from './Price.style';

class Price extends Component {

  render() {

    const { 
      header, middle, footer, priceContent,
      isOptional, currency, footerFeesOn,
      cashAmount, cashAmountOpt, 
      maxFeeCount, maxFeeCountOpt, 
      maxFeeAmount, maxFeeAmountOpt
    } = this.props;

    return (
      <PriceWrapper>
        <div className="Price-options-container">
          <div className="Price-value-container-on">
            <div className="Price-value-text-3" style={{'paddingTop': '5px'}}>{header}</div>
            <div className="Price-value-text-2">
              {`${currency} ${numberWithDots(isOptional ? cashAmountOpt : cashAmount)} ${middle}`}
            </div>
            <div className="Price-value-text-1" style={{'paddingBottom': '5px'}}>
              <div>
                {!footerFeesOn ? footer :
                `o hasta ${numberWithDots(isOptional ? maxFeeCountOpt : maxFeeCount)} cuotas de ${currency} ${numberWithDots(isOptional ? maxFeeAmountOpt : maxFeeAmount)}`}
                </div>
            </div>
          </div>
          <div className="Price-info-container">
            {priceContent()}
          </div>
        </div>
      </PriceWrapper>
    );
  }
}

Price.defaultProps = {
  header: 'Tu inversión será de',
  middle: 'al contado',
  footer: 'por año (precio contado)',
  footerFeesOn: true,
  currency: 'U$S',
  isOptional: false,
  priceContent: () => {}, 
};

const mapStateToProps = (state) => {
  return {
    cashAmount: state.quotation.cashAmount,
    maxFeeCount: state.quotation.maxFeeCount,
    maxFeeAmount: state.quotation.maxFeeAmount,
    
    cashAmountOpt: state.quotation.cashAmountOptional,
    maxFeeCountOpt: state.quotation.maxFeeCountOptional,
    maxFeeAmountOpt: state.quotation.maxFeeAmountOptional,
  };
};

export default connect(mapStateToProps, null)(Price);